import { logger } from '#pplx/frontend/logger/browser.js';
// Detects the current platform and dynamically imports the appropriate bridge implementation
// Returns undefined for unsupported platforms (which will fall back to DUMMY_NATIVE_BRIDGE)
export async function resolveNativeBridge() {
    try {
        // Check if running in Windows app by inspecting user agent
        const isWindowsApp = navigator.userAgent.includes('WindowsApp');
        if (isWindowsApp) {
            // Dynamically import Windows-specific bridge to avoid loading unnecessary code on other platforms
            const initializeBridge = await import('#pplx/frontend/apps/ask/xplat-app/bridge/index.js').then((mod) => mod.initialize);
            const bridge = initializeBridge();
            return bridge.createStore;
        }
        return undefined;
    }
    catch (error) {
        logger.error('Error resolving native bridge:', error);
        return undefined;
    }
}
//# sourceMappingURL=registry.js.map